import { repeatable, stringInputSpec } from '~/app/lib/editing-configs';
import UniversalContainer, {
  UniversalContainerProps,
} from '~/app/components/universal-container';
import FilterCategoryButton from './filter-category-button';
import FilterOptionButton from './filter-option-button';
import { MultilevelFiltersProps } from './multilevel-filters-types';
import { useMultilevelFilters } from './use-multilevel-filters';
import styles from './multilevel-filters.module.scss';

type Props = MultilevelFiltersProps & {
  container: UniversalContainerProps;
};

const MultilevelFilters = ({ filterCategories, container }: Props) => {
  const { filterOptions, handleFilterCategory, handleFilterOptionClick } =
    useMultilevelFilters({ filterCategories });

  return (
    <UniversalContainer {...container}>
      <div className={styles.container}>
        <FilterCategoryButton
          handleFilterCategory={handleFilterCategory}
          filterCategories={filterCategories}
        />
        <FilterOptionButton
          handleFilterOptionClick={handleFilterOptionClick}
          filterOptions={filterOptions}
        />
      </div>
    </UniversalContainer>
  );
};

MultilevelFilters.displayName = 'MultilevelFilters';

MultilevelFilters.getEditingConfig = (componentDocument: any) => {
  return [
    ...UniversalContainer.getEditingConfig(
      componentDocument,
      'Container',
      [
        'backgroundColor',
        'backgroundImage',
        'border',
        'margin',
        'padding',
        'hide',
        'jumpLinkId',
      ],
      'container'
    ),
    repeatable(
      'filterCategories',
      'Filter Categories',
      'Category',
      (filterCategoryIndex: number) => {
        const filterCategoryItem =
          componentDocument?.props?.filterCategories?.[filterCategoryIndex];

        return [
          stringInputSpec('categoryName', 'Category Name'),
          stringInputSpec('categoryValue', 'Category Value'),
          // only show filter options if category name and value is present
          filterCategoryItem?.categoryName && filterCategoryItem?.categoryValue
            ? repeatable('filterOptions', 'Filter Options', 'Option', () => [
                stringInputSpec('optionName', 'Option Name'),
                stringInputSpec('optionValue', 'Option Value'),
              ])
            : [],
        ];
      }
    ),
  ];
};

export default MultilevelFilters;
